export enum CommunityBase {
  community = 1,
  network = 2,
}
